import { STATICS } from 'statics'
import './style.scss'

export function CartCarouselArrow({
  className,
  isNext,
  disabled,
  onClick,
  icon = STATICS.ARROW_PREVIOUS,
}) {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`store-cart-carousel-arrow ${className || ''} ${isNext ? '-next' : ''} ${
        disabled ? '-disabled' : ''
      }`}
    >
      <div className='icon'>{icon}</div>
    </button>
  )
}
